const React = require('react');
const isNode = (typeof process !== 'undefined');
const GoogleMapReact = isNode ? require('google-map-react').default : <div/>;

const MapMarker = () => (
    <svg x="0px" y="0px" width="44px" height="44px" viewBox="0 0 44 44">
        <circle opacity="0.3" fill="#59222C" cx="22" cy="22" r="22"/>
        <circle fill="#59222C" cx="22" cy="22" r="3.3"/>
    </svg>
);

class MapGeneric extends React.Component {
    render() {
        const { latitude, longitude, width, height, zoom } = this.props;
        const mapWidth = width ? width : '100%';
        const mapHeight = height ? height : '500px';
        const mapZoom = zoom ? parseInt(zoom) : 13;
        return (
            <div style={{width: mapWidth, height: mapHeight, position: 'relative'}}>
                <GoogleMapReact
                    bootstrapURLKeys={{
                        key: 'AIzaSyA5fFrKr3uHkpsl5-2dktbYh2AHGaqfSsU'
                    }}
                    defaultCenter={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }}
                    defaultZoom={mapZoom}
                    resetBoundsOnResize={true}
                    style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}
                >
                    <MapMarker
                        lat={latitude}
                        lng={longitude}
                    />
                </GoogleMapReact>
            </div>
        )
    }
}

module.exports = MapGeneric;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/map-generic/Component/index.jsx